// SPDX-License-Identifier: AGPL-3.0-or-later

import {Switch} from '@app/features/ui/components/form/FormSwitch';
import styles from '@app/features/voice_scene/components/VoiceSceneAmbienceControl.module.css';
import VoiceSceneSettings from '@app/features/voice_scene/state/VoiceSceneSettings';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';
import {HandPalmIcon} from '@phosphor-icons/react';
import {observer} from 'mobx-react-lite';

const REFUSE_SLAPS_DESCRIPTOR = msg({
	message: 'Refuse slaps',
	comment:
		'Voice call 3D room: label and accessible name of the switch that turns off being slapped. On, a slap (T) at your character only swings through the air for everyone. Remembered on this device.',
});

// On, this client never answers a slap at my character, so nobody sees it land.
export const VoiceSceneSlapControl = observer(function VoiceSceneSlapControl() {
	const {i18n} = useLingui();
	const label = i18n._(REFUSE_SLAPS_DESCRIPTOR);
	return (
		<div className={styles.control} data-flx="voice-scene.voice-scene-slap-control.control">
			<HandPalmIcon className={styles.icon} aria-hidden="true" data-flx="voice-scene.voice-scene-slap-control.icon" />
			<span className={styles.label} data-flx="voice-scene.voice-scene-slap-control.label">
				{label}
			</span>
			<Switch
				compact
				value={VoiceSceneSettings.refuseSlaps}
				ariaLabel={label}
				onChange={(refuse) => VoiceSceneSettings.setRefuseSlaps(refuse)}
			/>
		</div>
	);
});
